/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
  FormGroup,
  InputGroup,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
  Badge,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { axiosGet, axiosPost } from "util/apiConfig.js";
import {
  privateSection,
  dateForPaymentListing,
  halfClass,
  fullClass,
} from "util/constance";
import moment from "moment";
// import CardBody from "reactstrap/lib/CardBody";
import Select from "react-select";
import classnames from "classnames";
import styles from "./SalesNotification.css";
import { Device } from "@twilio/voice-sdk";
import debounce from 'lodash/debounce';

const USER_STATE = {
  CONNECTING: "Connecting",
  READY: "Ready",
  ON_CALL: "On call",
  OFFLINE: "Offline",
}

const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: '8px',
    border: state.isFocused ? '1px solid #5e72e4' : '1px solid #e9ecef',
    boxShadow: state.isFocused ? '0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)' : 'none',
    minHeight: '43px',
    backgroundColor: '#fff',
    transition: 'all 0.15s ease',
    cursor: 'pointer',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 12px',
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '14px',
    color: '#adb5bd',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '14px',
    color: '#525f7f',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    backgroundColor: state.isSelected ? '#5e72e4' : state.isFocused ? '#f6f9fc' : '#fff',
    color: state.isSelected ? '#fff' : state.isFocused ? '#5e72e4' : '#525f7f',
    cursor: 'pointer',
    padding: '10px 12px',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '8px',
    boxShadow: '0 50px 100px rgba(50,50,93,.1),0 15px 35px rgba(50,50,93,.15),0 5px 15px rgba(0,0,0,.1)',
    border: '1px solid #e9ecef',
    zIndex: 9999,
  }),
};


class PrivateSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      activeTab: "1",
      allPrivateSection: [],
      allSections: [],
      allSectionsData: [],
      teachersList: [],
      showAddHocClass: false,
      sectionName: null,
      sectionNameError: null,
      startDate: null,
      startDateError: null,
      startTime: null,
      startTimeError: null,
      endTime: null,
      endTimeError: null,
      teacherName: null,
      roomUrl: null,
      timeZone: null,
      isFree: false,
      uploading: false,

      page: 1,
      totalPage: 0,
      limit: 10,

      successModal: false,
      successMessage: "",
      errorModal: false,
      errorMessage: "",
      modalTitle: "",
      message: "",
      classId: null,
      activeCard: "active",
      sortOrder: '',
      total: 0,
      userState: USER_STATE.OFFLINE,
      messageStates: {},
      searchValue: '',

      ignoreModal: false,
      ignoreDate: "",
      ignoreNote: "",
      selectedIgnoreData: null,
      endDateFrom: "",
      endDateTo: "",
    };
    this.debouncedSearch = debounce(this.getAllPrivateSection, 700);
  }

  componentDidMount() {
    let storage = localStorage.getItem('Sanga_Admin');
    storage = storage ? JSON.parse(storage) : null;
    const classId = localStorage.getItem("classId");
    this.setState(
      {
        classId: classId ? classId : null,
        allPrivateSection: [],
        allSections: [],
        allSectionsData: [],
        userType: storage && storage.userType,
        loading: true,
      },
      () => {
        this.getAllPrivateSection();
        this.getAllSections();
        this.getAllTeachers();
      }
    );
  }

  getAllTeachers = () => {
    let teachers = [{ value: null, label: "All Coaches" }];
    this.setState({ loading: true });
    axiosGet(`teacher/list-of-all-teacher`)
      .then((response) => {
        if (!response.isError) {
          let data = response.data?.result || [];
          data.map((_data) => {
            teachers.push({ value: _data.teacherId, label: _data.name });
          });
          this.setState({
            teachersList: teachers,
            loading: false,
          });
        } else {
          this.setState({
            teachersList: teachers,
            loading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          teachersList: teachers,
          loading: false,
        });
      });
  };

  searchSection = async (e) => {
    let val = e.target.value;
    this.setState({ searchValue: val, page: 1 }, () => {
      this.debouncedSearch(val);
    });
  };

  // for getting all approved student -
  getAllPrivateSection = async (sectionName = null) => {
    const { page, limit, filterTeacher, classId, activeCard, sortOrder, endDateFrom, endDateTo, searchValue } = this.state;

    let url = `section/get-private-sections/1/1000000?sectionType=${privateSection}&status=${activeCard}`;

    if (classId) {
      url += `&classId=${classId}`;
    }
    const search = sectionName !== null ? sectionName : searchValue;
    if (search) {
      url += `&sectionName=${search}`;
    }
    if (sortOrder) {
      url += `&sortOrder=${sortOrder}`;
    }
    if (filterTeacher) {
      url += `&teacherId=${filterTeacher}`;
    }
    if (endDateFrom) {
      url += `&endDateFrom=${endDateFrom}`;
    }
    if (endDateTo) {
      url += `&endDateTo=${endDateTo}`;
    }

    this.setState({ loading: true });
    await axiosGet(url)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            loading: false,
            allPrivateSection: response.data?.result || [],
            totalPage: Math.ceil(response.data?.result?.length / limit),
            total: response.data?.total,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // for getting all section list for add hoc class-
  getAllSections = () => {
    this.setState({ loading: true });
    axiosGet(`section/get-sections-dropdown`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            loading: false,
            allSections: response.data,
          });
          this.setSectionData(response.data);
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  setSectionData = (sectionData) => {
    let newObj = [];
    sectionData.map((data) => {
      let tt = { value: data.sectionId, label: data.name };
      newObj.push(tt);
    });
    let allSectionsData = newObj;
    this.setState({ allSectionsData });
  };
  // For changing page -
  changePage = (status) => {
    const { page, totalPage } = this.state;
    if (status && status === "next") {
      if (page < totalPage) {
        this.setState({ page: this.state.page + 1 });
      }
    } else if (status && status === "prev") {
      if (page > 1) {
        this.setState({ page: this.state.page - 1 });
      }
    } else if (typeof status === 'number') {
      this.setState({ page: status });
    }
  };

  //redirect to URL
  redirectToUrl = (urlToRedirect, token = null) => {
    urlToRedirect =
      urlToRedirect.includes("http") || urlToRedirect.includes("https")
        ? urlToRedirect
        : `http://${urlToRedirect}`;
    if (token) {
      urlToRedirect = `${urlToRedirect}?token=${token}`;
    }
    window.open(`${urlToRedirect}`, "_blank");
    return false;
  };

  redirectToUrlCard = (urlToRedirect) => {
    const newURL = urlToRedirect.replace('userdashboardpreview', 'payment')
    window.open(`${newURL}`, "_blank");
    return false;
  };

  //redirect to section
  goToSection = (classId, sectionId) => {
    // this.props.history.push({
    //   pathname: "/admin/section",
    //   state: { classId: classId, sectionId: sectionId },
    // });

    const url = `/admin/section?classId=${classId}&sectionId=${sectionId}`;
    window.open(url, "_blank");
  };

  //redirect to section
  sendMail = (classId, sectionId) => {
    let confirm = window.confirm("Are you sure you want to Send Mail?");
    if (confirm) {
      axiosPost(`section/send-email-private-section/${sectionId}`)
        .then((response) => {
          if (!response.isError) {
            this.setState(
              {
                successModal: true,
                modalTitle: "Success",
                message: "Mail sent it successfully.",
              },
              () => {
              }
            );
          } else {
            this.setState({
              errorModal: true,
              modalTitle: "Sorry!",
              message: response.message
                ? response.message
                : "Something is wrong. Try again later.",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            errorModal: true,
            modalTitle: "Sorry!",
            message: error.message
              ? error.message
              : "Something is wrong. Try again later.",
          });
        });
    }
  };

  showAddHocClassModal = (showAddHocClass) => {
    this.setState({
      showAddHocClass: !showAddHocClass,
    });
  };

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
      modalTitle: "",
      message: "",
    });
  };

  handleSectionChange = (e) => {
    let { allSections } = this.state;
    let getSection = allSections.find((data) => data.sectionId === e.value);
    this.setState({
      sectionName: e,
      teacherName: getSection.teacherName,
      roomUrl: getSection.roomURL,
      timeZone: getSection.localTimeZone,
    });
  };

  resetAddHocForm = () => {
    this.setState({
      sectionName: null,
      startDate: null,
      startTime: null,
      endTime: null,
      teacherName: null,
      roomUrl: null,
      timeZone: null,
      uploading: false,
      sectionNameError: false,
      startDateError: false,
      startTimeError: false,
      endTimeError: false,
    });
  };

  resetWithoutTimeAddHocForm = () => {
    this.setState({
      sectionName: null,
      sectionNameError: false
    });
  };

  saveAddhocClass = () => {
    let { sectionName, startDate, startTime, endTime, timeZone, isFree } = this.state;

    !sectionName
      ? this.setState({ sectionNameError: true })
      : this.setState({ sectionNameError: false });
    !startDate
      ? this.setState({ startDateError: true })
      : this.setState({ startDateError: false });
    !startTime
      ? this.setState({ startTimeError: true })
      : this.setState({ startTimeError: false });
    !endTime
      ? this.setState({ endTimeError: true })
      : this.setState({ endTimeError: false });

    if (sectionName && startDate && startTime && endTime) {
      let timeSplitStart = startTime.split(":");
      let timeSplitEnd = endTime.split(":");

      let startingTime = "";
      let endingTime = "";

      if (timeSplitStart && timeSplitStart[0] && timeSplitStart[1]) {
        let startHours = "";
        let status = "";
        timeSplitStart[0] >= 12
          ? (startHours = parseInt(parseInt(timeSplitStart[0]) - 12))
          : (startHours = timeSplitStart[0]);
        timeSplitStart[0] >= 12 ? (status = "PM") : (status = "AM");
        startingTime = startHours + ":" + timeSplitStart[1] + " " + status;
      }
      if (timeSplitEnd && timeSplitEnd[0] && timeSplitEnd[1]) {
        let startHours = "";
        let status = "";
        timeSplitEnd[0] >= 12
          ? (startHours = parseInt(parseInt(timeSplitEnd[0]) - 12))
          : (startHours = timeSplitEnd[0]);
        timeSplitEnd[0] >= 12 ? (status = "PM") : (status = "AM");
        endingTime = startHours + ":" + timeSplitEnd[1] + " " + status;
      }

      this.setState({ uploading: true });
      let dataToSend = {
        sectionId: sectionName.value,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        startTime: startingTime,
        endTime: endingTime,
        localTimeZone: timeZone,
        isFree: isFree,
      };
      axiosPost(`section/add-extra-session`, dataToSend)
        .then((response) => {
          this.setState({
            uploading: false,
            showAddHocClass: false,
          });
          if (!response.isError) {
            this.setState(
              {
                successModal: true,
                modalTitle: "Success",
                message: "Successfully saved.",
              },
              () => {
                this.resetAddHocForm();
              }
            );
          } else {
            this.setState(
              {
                errorModal: true,
                modalTitle: "Sorry!",
                message: response.message,
              },
              () => {
                this.resetAddHocForm();
              }
            );
          }
        })
        .catch((errorResponse) => {
          this.setState(
            {
              errorModal: true,
              uploading: false,
              showAddHocClass: false,
              modalTitle: "Sorry!",
              message: errorResponse.message,
            },
            () => {
              this.resetAddHocForm();
            }
          );
        });
    }
  };

  saveNotificationToParent = () => {
    let { sectionName, isFree } = this.state;
    !sectionName
      ? this.setState({ sectionNameError: true })
      : this.setState({ sectionNameError: false });
    let dataToSend = {
      sectionId: sectionName.value,
      isFree
    };
    if (sectionName) {
      axiosPost(`makeup/send-email-notification-parent`, dataToSend)
        .then((response) => {
          this.setState({
            uploading: false,
            showAddHocClass: false,
          });
          if (!response.isError) {
            this.setState(
              {
                successModal: true,
                modalTitle: "Success",
                message: "Sent email successfully.",
              },
              () => {
                this.resetWithoutTimeAddHocForm();
              }
            );
          } else {
            this.setState(
              {
                errorModal: true,
                modalTitle: "Sorry!",
                message: response.message,
              },
              () => {
                this.resetWithoutTimeAddHocForm();
              }
            );
          }
        })
        .catch((errorResponse) => {
          this.setState(
            {
              errorModal: true,
              uploading: false,
              showAddHocClass: false,
              modalTitle: "Sorry!",
              message: errorResponse.message,
            },
            () => {
              this.resetWithoutTimeAddHocForm();
            }
          );
        });
    }
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  calculateMonthGapMessage = (dateString) => {
    if (!dateString) {
      return 'red'
    }
    const createdAtDate = new Date(dateString);
    const currentDate = new Date();
    const monthsDiff = (currentDate.getFullYear() - createdAtDate.getFullYear()) * 12 +
      (currentDate.getMonth() - createdAtDate.getMonth());
    if (monthsDiff === 0) {
      return 'green'
    }
    return 'red'
  }

  getBelt = (belt) => {
    if (!belt) {
      return 'red'
    }
    if (belt == 'TBD') {
      return 'red'
    }
    return belt.toLowerCase()
  }

  calculateMonthGapCuriculum = (chapterLockStatus) => {
    if (!chapterLockStatus || chapterLockStatus.length === 0) {
      return 'red'
    }
    const lockedObjects = chapterLockStatus.filter((obj) => !obj.isLocked);
    lockedObjects.sort((a, b) => b.updatedAt - a.updatedAt);
    const latestUpdatedAt = lockedObjects.length > 0 ? lockedObjects[0].updatedAt : null;
    if (!latestUpdatedAt) {
      return 'red'
    }
    this.calculateMonthGapMessage(latestUpdatedAt)
  }

  handleSort = () => {
    const { sortOrder } = this.state;
    if (sortOrder === 'asc') {
      this.setState({ sortOrder: 'desc', page: 1 }, () => {
        this.getAllPrivateSection()
      });
    } else {
      this.setState({ sortOrder: 'asc', page: 1 }, () => {
        this.getAllPrivateSection()
      });
    }
  }

  isTimeInRange(timezone) {
    const now = new Date();
    const userTime = new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: false, timeZone: timezone }).format(now);
    const hour = parseInt(userTime, 10);

    // Check if the time is between 8 AM (8) and 9 PM (21)
    return hour >= 8 && hour < 21;
  }

  updateMessageState = (index, newState) => {
    this.setState(prevState => ({
      messageStates: {
        ...prevState.messageStates,
        [index]: newState
      }
    }));
  };

  callInit = (sale, index) => {
    axiosPost('sales/token', {})
      .then((response) => {
        if (!response.isError) {
          this.setState(
            {
              loading: false
            },
            () => {
              const token = response.data.token;
              const device = new Device(token, {
                logLevel: 1,
                codecPreferences: ["opus", "pcmu"],
              });
              device.register();
              this.setState({ device })
              device.addListener("connect", (device) => {
                console.log("Connect event listener added .....");
                return device;
              });
              device.on("registered", () => {
                console.log("Agent registered");
                this.setState({ userState: USER_STATE.READY });
              });
              device.on("connect", (connection) => {
                console.log("Call connect");
                this.setState({ userState: USER_STATE.ON_CALL })
              });
              device.on("disconnect", () => {
                console.log("Disconnect event");
                this.setState({ userState: USER_STATE.READY })
              });

              setTimeout(() => {
                this.handleCall(sale, index)
              }, 1000)
              return () => {
                device.destroy();
                this.setState({ device: undefined })
                this.setState({ userState: USER_STATE.OFFLINE })
              };
            }
          );
        } else {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorModal: true,
          modalTitle: 'Sorry!',
          message: 'Something is wrong. Try again later.',
        });
        console.log(error);
      });
  }

  handleCall = async (sale, index) => {
    const confirm = window.confirm(`Are you sure want to call? \nPlease verify details\nSection name: ${sale?.sectionName || ''},\nMobile: ${sale.mobileNumber || ''}, `)
    if (!confirm) {
      return false;
    }
    const { device } = this.state;
    device.emit("connect");
    device.connect({ params: { To: `${sale.mobileNumber.replace('-', '')}`, sectionId: sale.sectionId, classId: sale.classId } }).then((call) => {
      call.on("accept", () => {
        this.updateMessageState(index, USER_STATE.ON_CALL);
        console.log("call accepted");
      });
      call.on("disconnect", () => {
        console.log("The call has been disconnected.");
        this.updateMessageState(index, USER_STATE.READY);
      });
      call.on("reject", () => {
        console.log("The call was rejected.");
      });
      call.on("cancel", () => {
        console.log("The call was rejected.");
        this.updateMessageState(index, USER_STATE.READY);
      });
    })
  };


  rejectCall = () => {
    const { device, selectedNumber } = this.state
    device.emit("disconnect");
    device.emit("cancel");
    device.emit("reject");
    device.disconnectAll({ params: { To: selectedNumber } });
  }

  clientConnect = (index) => {
    let { allPrivateSection } = this.state;
    let selectedNotification = allPrivateSection[index];
    this.setState({
      notificationCallModal: true,
      selectedNumber: selectedNotification.mobileNumber.replace('-', '') || '',
      selectedClassId: selectedNotification.classId || ''
    });
  };

  replyMessageResponse = () => {
    let confirm = window.confirm('Are you sure want send message?');
    if (confirm) {
      let { twillioMessage, loading, selectedNumber } = this.state;
      if (!twillioMessage || twillioMessage == '') {
        return alert('Please enter message');
      }
      if (twillioMessage && !loading) {
        this.setState({ loading: true });
        let dataToSend = {
          message: twillioMessage,
          to: `${selectedNumber}`,
          classId: this.state.selectedClassId
        };
        // API -
        axiosPost('message/send-reply', dataToSend)
          .then((response) => {
            if (!response.isError) {
              this.setState(
                {
                  loading: false,
                  notificationCallModal: false,
                  twillioMessage: '',
                  selectedNumber: '',
                },
                () => {
                }
              );
            } else {
              this.setState({
                loading: false,
                modalTitle: 'Sorry!',
                message: 'Something is wrong. Try again later.',
                notificationCallModal: false,
                twillioMessage: '',
                selectedNumber: '',
              });
            }
          })
          .catch((error) => {
            this.setState({
              loading: false,
              errorModal: true,
              message: 'Something is wrong. Try again later.',
              notificationCallModal: false,
              twillioMessage: '',
              selectedNumber: '',
            });
          });
      }
    }
  };

  toggleIgnoreModal = (data = null) => {
    this.setState({
      ignoreModal: !this.state.ignoreModal,
      selectedIgnoreData: data,
      ignoreDate: "",
      ignoreNote: "",
    });
  };

  handleIgnoreSave = () => {
    const { ignoreDate, ignoreNote, selectedIgnoreData } = this.state;
    if (!ignoreDate) {
      alert("Please select an ignore date");
      return;
    }

    this.setState({ loading: true });
    const dataToSend = {
      sectionId: selectedIgnoreData.sectionId,
      email: selectedIgnoreData.email,
      ignoreDate: ignoreDate,
      privateNote: ignoreNote,
    };

    axiosPost("section/update-private-section-ignore", dataToSend)
      .then((response) => {
        this.setState({ loading: false, ignoreModal: false });
        if (!response.isError) {
          this.setState({
            successModal: true,
            modalTitle: "Success",
            message: "Subscription ignored successfully.",
          });
          this.getAllPrivateSection();
        } else {
          this.setState({
            errorModal: true,
            modalTitle: "Error",
            message: response.message || "Failed to ignore subscription.",
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          ignoreModal: false,
          errorModal: true,
          modalTitle: "Error",
          message: error.message || "Something went wrong.",
        });
      });
  };

  render() {
    let {
      allPrivateSection,
      page,
      totalPage,
      limit,
      showAddHocClass,
      sectionName,
      sectionNameError,
      allSectionsData,
      startDate,
      startDateError,
      endTime,
      endTimeError,
      startTime,
      startTimeError,
      teacherName,
      roomUrl,
      timeZone,
      uploading,
      message,
      successModal,
      errorModal,
      activeTab,
      teachersList,
      modalTitle,
      activeCard,
      isFree,
      sortOrder,
      notificationCallModal,
      notesError,
      twillioMessage,
      loading,
      userType,
      endDateFrom,
      endDateTo
    } = this.state;
    const totalCount = allPrivateSection ? allPrivateSection.length : 0;
    const activeCount = allPrivateSection ? allPrivateSection.filter(d => d.stripeSubscriptionStatus === 'active').length : 0;
    const ignoredCount = allPrivateSection ? allPrivateSection.filter(d => d.ignoreStatus && moment().isSameOrBefore(moment(d.ignoreStatus.ignoreDate), 'day')).length : 0;
    const expiredCount = allPrivateSection ? allPrivateSection.filter(d => new Date() > new Date(d.endDate)).length : 0;

    return (
      <>
        <style>{`
          .hover-row {
            transition: all 0.2s ease-in-out;
          }
          .hover-row:hover {
            transform: translateY(-2px);
            box-shadow: 0 12px 28px rgba(50,50,93,0.06), 0 2px 6px rgba(0,0,0,0.02) !important;
            background-color: #fbfcff !important;
            z-index: 10;
            position: relative;
          }
        `}</style>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* KPI Summary Cards */}
          <Row className="mb-4">
            <Col xl="3" lg="6" sm="6" xs="12" className="mb-4 mb-xl-0">
              <Card className="card-stats shadow border-0" style={{ borderRadius: '15px', backgroundColor: '#fff', borderLeft: '5px solid #5e72e4' }}>
                <CardBody className="p-3">
                  <Row className="align-items-center">
                    <div className="col">
                      <span className="h6 text-muted text-uppercase font-weight-700 mb-0" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Total Private</span>
                      <div className="h2 font-weight-bold mb-0 mt-1" style={{ fontSize: '22px' }}>{totalCount}</div>
                    </div>
                    <Col className="col-auto">
                      <div className="icon icon-shape bg-primary text-white rounded-circle shadow" style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fa fa-list" style={{ fontSize: '14px' }} />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl="3" lg="6" sm="6" xs="12" className="mb-4 mb-xl-0">
              <Card className="card-stats shadow border-0" style={{ borderRadius: '15px', backgroundColor: '#fff', borderLeft: '5px solid #2dce89' }}>
                <CardBody className="p-3">
                  <Row className="align-items-center">
                    <div className="col">
                      <span className="h6 text-muted text-uppercase font-weight-700 mb-0" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Active Stripe</span>
                      <div className="h2 font-weight-bold mb-0 mt-1 text-success" style={{ fontSize: '22px' }}>{activeCount}</div>
                    </div>
                    <Col className="col-auto">
                      <div className="icon icon-shape bg-success text-white rounded-circle shadow" style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fa fa-check" style={{ fontSize: '14px' }} />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl="3" lg="6" sm="6" xs="12" className="mb-4 mb-sm-0">
              <Card className="card-stats shadow border-0" style={{ borderRadius: '15px', backgroundColor: '#fff', borderLeft: '5px solid #11cdef' }}>
                <CardBody className="p-3">
                  <Row className="align-items-center">
                    <div className="col">
                      <span className="h6 text-muted text-uppercase font-weight-700 mb-0" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Ignored Status</span>
                      <div className="h2 font-weight-bold mb-0 mt-1 text-info" style={{ fontSize: '22px' }}>{ignoredCount}</div>
                    </div>
                    <Col className="col-auto">
                      <div className="icon icon-shape bg-info text-white rounded-circle shadow" style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fa fa-bell-slash" style={{ fontSize: '14px' }} />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl="3" lg="6" sm="6" xs="12">
              <Card className="card-stats shadow border-0" style={{ borderRadius: '15px', backgroundColor: '#fff', borderLeft: '5px solid #fb6340' }}>
                <CardBody className="p-3">
                  <Row className="align-items-center">
                    <div className="col">
                      <span className="h6 text-muted text-uppercase font-weight-700 mb-0" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Expired Plan</span>
                      <div className="h2 font-weight-bold mb-0 mt-1 text-warning" style={{ fontSize: '22px' }}>{expiredCount}</div>
                    </div>
                    <Col className="col-auto">
                      <div className="icon icon-shape bg-warning text-white rounded-circle shadow" style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fa fa-calendar-times" style={{ fontSize: '14px' }} />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* Table */}
          <Row>

            <div className="col">
              <Card className="shadow border-0" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                <CardHeader className="bg-transparent border-0 d-flex flex-column flex-sm-row justify-content-between align-items-sm-center py-4" style={{ gap: '15px' }}>
                  <h3 className="mb-0 text-primary font-weight-700" style={{ fontSize: '20px' }}>All Private Section</h3>
                  <Button
                    color="primary"
                    type="button"
                    className="shadow-sm font-weight-600 px-4"
                    style={{ borderRadius: '8px' }}
                    onClick={() => this.showAddHocClassModal(showAddHocClass)}
                  >
                    <i className="fa fa-plus mr-2" />
                    Add AddHoc Class
                  </Button>
                </CardHeader>

                <CardBody className="pt-0">
                  <Row className="mb-4">
                    <Col className="d-flex justify-content-center justify-content-sm-start">
                      <Nav pills className="nav-fill flex-row w-100" style={{ maxWidth: '320px', backgroundColor: '#f1f3f9', padding: '4px', borderRadius: '12px', boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)' }}>
                        <NavItem className="w-50">
                          <NavLink
                            className={classnames("py-2 text-center font-weight-700", { active: activeCard === "active" })}
                            onClick={() => {
                              this.setState({ activeCard: "active", page: 1 }, () => {
                                this.getAllPrivateSection();
                              });
                            }}
                            style={{ cursor: "pointer", borderRadius: '9px', fontSize: '13px', transition: 'all 0.2s ease', border: 'none' }}
                          >
                            <i className="fa fa-check-circle mr-1.5" /> Active
                          </NavLink>
                        </NavItem>
                        <NavItem className="w-50">
                          <NavLink
                            className={classnames("py-2 text-center font-weight-700", { active: activeCard === "inactive" })}
                            onClick={() => {
                              this.setState({ activeCard: "inactive", page: 1 }, () => {
                                this.getAllPrivateSection();
                              });
                            }}
                            style={{ cursor: "pointer", borderRadius: '9px', fontSize: '13px', transition: 'all 0.2s ease', border: 'none' }}
                          >
                            <i className="fa fa-times-circle mr-1.5" /> Expired
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Col>
                  </Row>
                  
                  <Row className="align-items-end" style={{ rowGap: '15px' }}>
                    <Col xs="12" sm="6" lg="3" xl="3">
                      <FormGroup className="mb-0">
                        <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>SEARCH</label>
                        <div className="d-flex align-items-center" style={{ borderRadius: '8px', border: '1px solid #e9ecef', backgroundColor: '#fff', height: '43px', padding: '0 12px', transition: 'all 0.15s ease' }}>
                          <i className="fa fa-search text-muted mr-2" style={{ fontSize: '13px' }} />
                          <input
                            placeholder="Section name or Email"
                            type="text"
                            name="search"
                            value={this.state.searchValue}
                            className="w-100"
                            style={{ border: 'none', outline: 'none', fontSize: '14px', color: '#525f7f', backgroundColor: 'transparent' }}
                            onChange={(e) => this.setState({ searchValue: e.target.value })}
                          />
                        </div>
                      </FormGroup>
                    </Col>

                    <Col xs="12" sm="6" lg="2" xl="2">
                      <FormGroup className="mb-0">
                        <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>COACH</label>
                        <Select
                          options={teachersList}
                          placeholder="All Coaches"
                          isSearchable={true}
                          value={teachersList.find(t => t.value === this.state.filterTeacher)}
                          styles={selectCustomStyles}
                          onChange={(e) => {
                            this.setState({ filterTeacher: e ? e.value : null });
                          }}
                        />
                      </FormGroup>
                    </Col>

                    <Col xs="12" sm="6" lg="2" xl="2">
                      <FormGroup className="mb-0">
                        <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>END DATE FROM</label>
                        <div className="d-flex align-items-center" style={{ borderRadius: '8px', border: '1px solid #e9ecef', backgroundColor: '#fff', height: '43px', padding: '0 12px', transition: 'all 0.15s ease' }}>
                          <i className="fa fa-calendar-alt text-muted mr-2" style={{ fontSize: '13px' }} />
                          <input
                            type="date"
                            className="w-100"
                            style={{ border: 'none', outline: 'none', fontSize: '14px', color: '#525f7f', backgroundColor: 'transparent' }}
                            value={endDateFrom}
                            onChange={(e) => this.setState({ endDateFrom: e.target.value })}
                          />
                        </div>
                      </FormGroup>
                    </Col>

                    <Col xs="12" sm="6" lg="2" xl="2">
                      <FormGroup className="mb-0">
                        <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>END DATE TO</label>
                        <div className="d-flex align-items-center" style={{ borderRadius: '8px', border: '1px solid #e9ecef', backgroundColor: '#fff', height: '43px', padding: '0 12px', transition: 'all 0.15s ease' }}>
                          <i className="fa fa-calendar-alt text-muted mr-2" style={{ fontSize: '13px' }} />
                          <input
                            type="date"
                            className="w-100"
                            style={{ border: 'none', outline: 'none', fontSize: '14px', color: '#525f7f', backgroundColor: 'transparent' }}
                            value={endDateTo}
                            onChange={(e) => this.setState({ endDateTo: e.target.value })}
                          />
                        </div>
                      </FormGroup>
                    </Col>

                    <Col xs="12" sm="12" lg="3" xl="3">
                      <div className="d-flex w-100" style={{ gap: '8px', height: '43px' }}>
                        <Button
                          color="primary"
                          className="w-100 font-weight-600 shadow-sm"
                          style={{ borderRadius: '8px', height: '43px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          onClick={() => {
                            this.setState({ page: 1 }, () => {
                              this.getAllPrivateSection(this.state.searchValue);
                            });
                          }}
                        >
                          <i className="fa fa-search mr-2" />
                          Search
                        </Button>
                        <Button
                          color="secondary"
                          className="font-weight-600 shadow-sm px-4"
                          style={{ borderRadius: '8px', border: '1px solid #e9ecef', height: '43px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          onClick={() => {
                            this.setState({
                              searchValue: "",
                              filterTeacher: null,
                              endDateFrom: "",
                              endDateTo: "",
                              page: 1
                            }, () => {
                              this.getAllPrivateSection();
                            });
                          }}
                        >
                          Reset
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>


                {loading ? (
                  <div className="text-center py-9">
                    <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                    <h3 className="mt-3 text-muted">Loading data...</h3>
                  </div>
                ) : (
                  <>
                    {/* Desktop View Table */}
                    <Table className="align-items-center table-flush d-none d-lg-table" responsive>
                      <thead className="thead-light">
                        <tr>
                          <th scope="col" style={{ width: '130px' }}>Contact Hub</th>
                          <th scope="col" style={{ width: '150px' }}>Insights</th>
                          <th scope="col">Student Info</th>
                          <th scope="col">Section Details</th>
                          <th scope="col">Coach / Length</th>
                          <th scope="col">Schedule & Timing</th>
                          <th scope="col">Duration</th>
                          <th scope="col" className="text-center">Sessions</th>
                          <th scope="col">Billing Status</th>
                          <th scope="col" style={{ width: '180px' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allPrivateSection &&
                          allPrivateSection.length > 0 &&
                          allPrivateSection.slice((page - 1) * limit, page * limit).map((data, index) => {
                            const globalIndex = (page - 1) * limit + index;
                            const isActiveTime = this.isTimeInRange(data?.localTimeZone || 'Asia/kolkata');
                            const activeDays = data?.daysOfWeek?.filter(day => day.isActive).map(day => day.name);
                            const isExpired = new Date() > new Date(data.endDate);
                            const isNotActive = data.stripeSubscriptionStatus !== 'active';
                            const isIgnored = !!data.ignoreStatus && moment().isSameOrBefore(moment(data.ignoreStatus.ignoreDate), 'day');
                            const isActive = Object.values(this.state.messageStates).some(
                              state => state === 'Connecting' || state === 'On call'
                            )
                            const userStateForMessage = this.state.messageStates[globalIndex] || USER_STATE.OFFLINE;

                            let rowStyle = {};
                            let firstCellStyle = { width: '130px' };
                            if (isIgnored) {
                              rowStyle = { backgroundColor: '#f0fbfd' };
                              firstCellStyle = { ...firstCellStyle, borderLeft: '5px solid #11cdef' };
                            } else if (isNotActive) {
                              rowStyle = { backgroundColor: '#fff5f6' };
                              firstCellStyle = { ...firstCellStyle, borderLeft: '5px solid #f5365c' };
                            } else if (isExpired) {
                              rowStyle = { backgroundColor: '#fff9f6' };
                              firstCellStyle = { ...firstCellStyle, borderLeft: '5px solid #fb6340' };
                            }

                            return (
                              <tr key={globalIndex} className="hover-row" style={rowStyle}>
                                <td className="table-column-width" style={firstCellStyle}>
                                  <div className="d-flex align-items-center justify-content-start">
                                    {userStateForMessage === 'Connecting' || userStateForMessage === 'On call' ? (
                                      <Button
                                        color="danger"
                                        size="sm"
                                        className="btn-icon-only rounded-circle mr-2"
                                        onClick={() => this.rejectCall(data.mobile)}
                                        title="Hang up call"
                                      >
                                        <i className="fa fa-phone" style={{ fontSize: '14px' }} />
                                      </Button>
                                    ) : (
                                      <Button
                                        color="secondary"
                                        size="sm"
                                        className="btn-icon-only rounded-circle mr-2"
                                        disabled={isActive}
                                        onClick={() => this.callInit(data, globalIndex)}
                                        title="Start voice call"
                                      >
                                        <i className="fa fa-phone text-success" style={{ fontSize: '14px' }} />
                                      </Button>
                                    )}
                                    <Button
                                      color="secondary"
                                      size="sm"
                                      className="btn-icon-only rounded-circle"
                                      onClick={() => this.clientConnect(globalIndex)}
                                      title="Open chat message history"
                                    >
                                      <i className="fa fa-comments text-primary" style={{ fontSize: '14px' }} />
                                    </Button>
                                  </div>
                                </td>

                                <td>
                                  <div className="d-flex align-items-center">
                                    {/* Belt (beginner/intermediate/advanced) is a Chess-only concept. */}
                                    {data?.classId === 'CLASS1648760926141' && data?.belt && (
                                      <Badge
                                        color="secondary"
                                        className="badge-dot mr-2"
                                        style={{ border: '1px solid #e9ecef', padding: '4px 8px' }}
                                        title={`Belt color: ${data.belt}`}
                                      >
                                        <i style={{ backgroundColor: this.getBelt(data?.belt) }} />
                                        <span className="text-dark" style={{ textTransform: 'capitalize' }}>{data.belt}</span>
                                      </Badge>
                                    )}
                                    <span
                                      className="fa fa-comments mr-2"
                                      style={{
                                        color: this.calculateMonthGapMessage(data?.messages?.createdAt || null),
                                        fontSize: '16px',
                                        cursor: 'help'
                                      }}
                                      title="Message gap status indicator"
                                    />
                                    <span
                                      className="fa fa-book"
                                      style={{
                                        color: this.calculateMonthGapCuriculum(data?.chapterLockStatus || []),
                                        fontSize: '16px',
                                        cursor: 'help'
                                      }}
                                      title="Curriculum lock status indicator"
                                    />
                                  </div>
                                </td>

                                <td>
                                  <div className="d-flex flex-column">
                                    {data.email ? (
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={'/admin/student-management?sectionId=' + data.sectionId}
                                        className="text-primary font-weight-bold"
                                        style={{ fontSize: '13px' }}
                                      >
                                        {data.email}
                                      </a>
                                    ) : (
                                      <span className="text-muted">N/A</span>
                                    )}
                                    {data.mobileNumber && (
                                      <a
                                        href={"tel:" + data.mobileNumber}
                                        className="text-muted mt-1"
                                        style={{ fontSize: '11px' }}
                                      >
                                        <i className="fa fa-phone mr-1" style={{ fontSize: '9px' }} />
                                        {data.mobileNumber}
                                      </a>
                                    )}
                                  </div>
                                </td>

                                <td>
                                  <div className="d-flex flex-column">
                                    {data.sectionName ? (
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.redirectToUrl(data.publicUrl);
                                        }}
                                        className="font-weight-600 text-dark"
                                        style={{ fontSize: '13px' }}
                                      >
                                        {data.sectionName}
                                      </a>
                                    ) : (
                                      <span className="text-muted">N/A</span>
                                    )}
                                    <div className="d-flex align-items-center mt-1" style={{ gap: '8px', fontSize: '11px' }}>
                                      {userType === 'admin' && (
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.redirectToUrlCard(data.publicUrl);
                                          }}
                                          className="text-info font-weight-500"
                                          title="Checkout Link"
                                        >
                                          <i className="fa fa-credit-card mr-1" />
                                          Checkout
                                        </a>
                                      )}
                                      {userType === 'admin' && <span className="text-muted">|</span>}
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.redirectToUrl(data.publicUrl, data.token);
                                        }}
                                        className="text-success font-weight-500"
                                      >
                                        <i className="fa fa-sync mr-1" />
                                        Update Sessions
                                      </a>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="d-flex flex-column">
                                    <span className="font-weight-600 text-dark" style={{ fontSize: '13px' }}>
                                      {data?.teacherName || 'No Coach'}
                                    </span>
                                    {data.classLength && (
                                      <span className="text-muted mt-1" style={{ fontSize: '11px' }}>
                                        <i className="fa fa-hourglass-half mr-1" style={{ fontSize: '10px' }} />
                                        {data.classLength == fullClass ? "Full (50 mins)" : data.classLength == halfClass ? "Half (25 mins)" : ""}
                                      </span>
                                    )}
                                  </div>
                                </td>

                                <td>
                                  <div className="d-flex flex-column">
                                    <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                                      {activeDays && activeDays.length > 0 ? (
                                        activeDays.map((day, dIdx) => (
                                          <Badge key={dIdx} color="primary" size="sm" className="badge-pill px-2 py-1" style={{ fontSize: '10px' }}>
                                            {day}
                                          </Badge>
                                        ))
                                      ) : (
                                        <span className="text-muted" style={{ fontSize: '11px' }}>No days</span>
                                      )}
                                    </div>
                                    {data.startTime && data.endTime && (
                                      <span className="text-dark mt-1 font-weight-500" style={{ fontSize: '12px' }}>
                                        <i className="fa fa-clock mr-1 text-muted" style={{ fontSize: '11px' }} />
                                        {data.startTime} - {data.endTime}
                                      </span>
                                    )}
                                    {data.localTimeZone && (
                                      <span className="text-muted" style={{ fontSize: '10px' }}>
                                        {data.localTimeZone}
                                      </span>
                                    )}
                                  </div>
                                </td>

                                <td>
                                  <div className="d-flex flex-column" style={{ fontSize: '12px' }}>
                                    {data.startDate && (
                                      <span className="text-success font-weight-500">
                                        <i className="fa fa-calendar-alt mr-1 text-muted" style={{ fontSize: '10px' }} />
                                        Start: {data.startLocalDate ? moment(data.startLocalDate, 'YYYY-MM-DD').format("DD-MM-YYYY") : moment(data.startDate).format("DD-MM-YYYY")}
                                      </span>
                                    )}
                                    {data.endDate && (
                                      <span className={isExpired ? "text-danger font-weight-500 mt-1" : "text-muted mt-1"}>
                                        <i className="fa fa-calendar-check mr-1 text-muted" style={{ fontSize: '10px' }} />
                                        End: {data.endLocalDate ? moment(data.endLocalDate, 'YYYY-MM-DD').format("DD-MM-YYYY") : moment(data.endDate).format("DD-MM-YYYY")}
                                      </span>
                                    )}
                                  </div>
                                </td>

                                <td className="text-center font-weight-bold" style={{ fontSize: '14px' }}>
                                  {data.numberOfSessions || 0}
                                </td>

                                <td>
                                  <div className="d-flex flex-column align-items-start">
                                    {data.stripeSubscriptionStatus ? (
                                      <Badge color={data.stripeSubscriptionStatus === 'active' ? 'success' : 'danger'} className="px-2 py-1">
                                        {data.stripeSubscriptionStatus.toUpperCase()}
                                      </Badge>
                                    ) : (
                                      <Badge color="danger" className="px-2 py-1">N/A</Badge>
                                    )}
                                    {isIgnored && data.ignoreStatus && (
                                      <div className="mt-2 p-2 rounded" style={{ backgroundColor: '#fff', border: '1px solid #e2f3f5', maxWidth: '160px' }}>
                                        <Badge color="info" className="px-2 py-0.5" style={{ fontSize: '9px' }}>IGNORED</Badge>
                                        <div className="text-muted mt-1" style={{ fontSize: '10px', fontWeight: '500' }}>
                                          Until: {moment(data.ignoreStatus.ignoreDate).format("DD-MM-YYYY")}
                                        </div>
                                        {data.ignoreStatus.privateNote && (
                                          <div className="text-wrap mt-1 text-dark" style={{ fontSize: '10px', fontStyle: 'italic', lineHeight: '1.2' }}>
                                            Reason: {data.ignoreStatus.privateNote}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </td>

                                <td>
                                  <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
                                    <Button
                                      color="primary"
                                      size="sm"
                                      className="px-2 py-1"
                                      onClick={() => this.goToSection(data.classId, data.sectionId)}
                                      title="Edit section"
                                    >
                                      <i className="fa fa-edit mr-1" />
                                      Edit
                                    </Button>
                                    {isNotActive && (
                                      <Button
                                        color={isIgnored ? "secondary" : "warning"}
                                        size="sm"
                                        className="px-2 py-1"
                                        onClick={() => this.toggleIgnoreModal(data)}
                                        title={isIgnored ? "Update ignore setting" : "Ignore subscription status"}
                                      >
                                        <i className="fa fa-bell-slash mr-1" />
                                        {isIgnored ? "Ignore Status" : "Ignore"}
                                      </Button>
                                    )}
                                    <Button
                                      color="info"
                                      size="sm"
                                      className="px-2 py-1"
                                      onClick={() => this.sendMail(data.classId, data.sectionId)}
                                      title="Send email sign-up credentials"
                                    >
                                      <i className="fa fa-envelope mr-1" />
                                      Mail Signup
                                    </Button>
                                    {data.zoomLink && (
                                      <Button
                                        color="success"
                                        size="sm"
                                        className="px-2 py-1"
                                        onClick={() => this.redirectToUrl(data.zoomLink)}
                                        title="Start zoom class session"
                                      >
                                        <i className="fa fa-video mr-1" />
                                        Start Class
                                      </Button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>

                    {/* Mobile/Tablet Card-List View */}
                    <div className="d-block d-lg-none px-3 py-3" style={{ backgroundColor: '#f8f9fe' }}>
                      {allPrivateSection && allPrivateSection.length > 0 ? (
                        allPrivateSection.slice((page - 1) * limit, page * limit).map((data, index) => {
                          const globalIndex = (page - 1) * limit + index;
                          const activeDays = data?.daysOfWeek?.filter(day => day.isActive).map(day => day.name);
                          const isExpired = new Date() > new Date(data.endDate);
                          const isNotActive = data.stripeSubscriptionStatus !== 'active';
                          const isIgnored = !!data.ignoreStatus && moment().isSameOrBefore(moment(data.ignoreStatus.ignoreDate), 'day');
                          const isActive = Object.values(this.state.messageStates).some(
                            state => state === 'Connecting' || state === 'On call'
                          )
                          const userStateForMessage = this.state.messageStates[globalIndex] || USER_STATE.OFFLINE;

                          let rowStyle = {};
                          let borderLeftStyle = '1px solid #e9ecef';
                          if (isIgnored) {
                            rowStyle = { backgroundColor: '#f0fbfd' };
                            borderLeftStyle = '6px solid #11cdef';
                          } else if (isNotActive) {
                            rowStyle = { backgroundColor: '#fff5f6' };
                            borderLeftStyle = '6px solid #f5365c';
                          } else if (isExpired) {
                            rowStyle = { backgroundColor: '#fff9f6' };
                            borderLeftStyle = '6px solid #fb6340';
                          }

                          return (
                            <Card key={globalIndex} className="mb-4 border-0" style={{ ...rowStyle, borderRadius: '16px', borderLeft: borderLeftStyle, boxShadow: '0 8px 24px rgba(50,50,93,.05),0 1px 3px rgba(0,0,0,.03)', overflow: 'hidden' }}>
                              <CardBody className="p-3">
                                {/* Header: Student Email & Stripe Status */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <div style={{ maxWidth: '65%' }}>
                                    <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '10px', letterSpacing: '0.8px' }}>Student</span>
                                    {data.email ? (
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={'/admin/student-management?sectionId=' + data.sectionId}
                                        className="text-primary font-weight-700 text-truncate d-block mt-0.5"
                                        style={{ fontSize: '14px', textDecoration: 'none' }}
                                      >
                                        {data.email}
                                      </a>
                                    ) : (
                                      <span className="text-muted font-weight-600 mt-0.5 d-block" style={{ fontSize: '13px' }}>N/A</span>
                                    )}
                                  </div>
                                  <div>
                                    {data.stripeSubscriptionStatus ? (
                                      <Badge color={data.stripeSubscriptionStatus === 'active' ? 'success' : 'danger'} className="px-2.5 py-1.5" style={{ borderRadius: '8px', fontSize: '10px', letterSpacing: '0.3px', fontWeight: '700' }}>
                                        {data.stripeSubscriptionStatus.toUpperCase()}
                                      </Badge>
                                    ) : (
                                      <Badge color="danger" className="px-2.5 py-1.5" style={{ borderRadius: '8px', fontSize: '10px', fontWeight: '700' }}>N/A</Badge>
                                    )}
                                  </div>
                                </div>

                                {/* Section Name & Helper Links */}
                                <div className="mb-3 p-2.5" style={{ backgroundColor: '#f8f9fe', borderRadius: '10px', border: '1px solid #f1f3f9' }}>
                                  <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Section & Checkout</span>
                                  <div className="mt-1 d-flex align-items-center justify-content-between">
                                    {data.sectionName ? (
                                      <a
                                        href="#"
                                        onClick={(e) => { e.preventDefault(); this.redirectToUrl(data.publicUrl); }}
                                        className="text-dark font-weight-700 text-truncate"
                                        style={{ fontSize: '13.5px', maxWidth: '60%', textDecoration: 'none' }}
                                      >
                                        {data.sectionName}
                                      </a>
                                    ) : (
                                      <span className="text-muted font-weight-600" style={{ fontSize: '13px' }}>N/A</span>
                                    )}

                                    {/* Insights (Belt, Chat Gap, Curriculum Gap) */}
                                    <div className="d-flex align-items-center ml-2">
                                      {data?.classId === 'CLASS1648760926141' && data?.belt && (
                                        <Badge
                                          color="secondary"
                                          className="badge-pill mr-2 px-2 py-1 d-flex align-items-center"
                                          style={{ border: '1px solid #e9ecef', textTransform: 'capitalize', fontSize: '10px', color: '#32325d' }}
                                        >
                                          <span style={{ display: 'inline-block', width: '6px', height: '6px', borderRadius: '50%', backgroundColor: this.getBelt(data?.belt), marginRight: '4px' }} />
                                          {data.belt}
                                        </Badge>
                                      )}
                                      <span
                                        className="fa fa-comments mr-2"
                                        style={{
                                          color: this.calculateMonthGapMessage(data?.messages?.createdAt || null),
                                          fontSize: '14px',
                                        }}
                                        title="Message gap status indicator"
                                      />
                                      <span
                                        className="fa fa-book"
                                        style={{
                                          color: this.calculateMonthGapCuriculum(data?.chapterLockStatus || []),
                                          fontSize: '14px',
                                        }}
                                        title="Curriculum lock status indicator"
                                      />
                                    </div>
                                  </div>
                                  
                                  <div className="d-flex mt-2 pt-2" style={{ gap: '12px', fontSize: '11px', borderTop: '1px dashed #e9ecef' }}>
                                    {userType === 'admin' && (
                                      <a
                                        href="#"
                                        onClick={(e) => { e.preventDefault(); this.redirectToUrlCard(data.publicUrl); }}
                                        className="text-info font-weight-700 d-flex align-items-center"
                                        style={{ textDecoration: 'none' }}
                                      >
                                        <i className="fa fa-credit-card mr-1" /> Checkout Link
                                      </a>
                                    )}
                                    {userType === 'admin' && <span className="text-muted">|</span>}
                                    <a
                                      href="#"
                                      onClick={(e) => { e.preventDefault(); this.redirectToUrl(data.publicUrl, data.token); }}
                                      className="text-success font-weight-700 d-flex align-items-center"
                                      style={{ textDecoration: 'none' }}
                                    >
                                      <i className="fa fa-sync mr-1" /> Update Sessions
                                    </a>
                                  </div>
                                </div>

                                {/* Details Grid (2-Column Dashboard Box) */}
                                <div className="row mb-3" style={{ rowGap: '12px' }}>
                                  <div className="col-6">
                                    <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Coach & Length</span>
                                    <div className="font-weight-700 text-dark mt-1" style={{ fontSize: '12.5px' }}>
                                      <i className="fa fa-user-tie mr-1 text-primary" style={{ fontSize: '11px' }} />
                                      {data?.teacherName || 'No Coach'}
                                    </div>
                                    <div className="text-muted font-weight-600 mt-0.5" style={{ fontSize: '11px' }}>
                                      {data.classLength == fullClass ? "Full class (50m)" : data.classLength == halfClass ? "Half class (25m)" : "N/A"}
                                    </div>
                                  </div>

                                  <div className="col-6">
                                    <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Timing & Days</span>
                                    {data.startTime && data.endTime ? (
                                      <div className="text-dark font-weight-700 mt-1" style={{ fontSize: '12px' }}>
                                        <i className="fa fa-clock mr-1 text-info" style={{ fontSize: '11px' }} />
                                        {data.startTime} - {data.endTime}
                                      </div>
                                    ) : (
                                      <div className="text-muted font-weight-600 mt-1" style={{ fontSize: '11px' }}>N/A</div>
                                    )}
                                    <div className="d-flex flex-wrap mt-1" style={{ gap: '3px' }}>
                                      {activeDays && activeDays.length > 0 ? (
                                        activeDays.map((day, dIdx) => (
                                          <Badge key={dIdx} color="primary" size="sm" className="badge-pill px-2 py-0.5" style={{ fontSize: '8.5px', fontWeight: '700' }}>
                                            {day}
                                          </Badge>
                                        ))
                                      ) : (
                                        <span className="text-muted" style={{ fontSize: '10px' }}>No days</span>
                                      )}
                                    </div>
                                  </div>

                                  <div className="col-6">
                                    <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Duration Range</span>
                                    <div className="font-weight-600 mt-1" style={{ fontSize: '11px', lineHeight: '1.4' }}>
                                      {data.startDate && (
                                        <div className="text-success d-flex align-items-center">
                                          <i className="fa fa-calendar-alt mr-1" style={{ fontSize: '10px' }} />
                                          Start: {data.startLocalDate ? moment(data.startLocalDate, 'YYYY-MM-DD').format("DD-MM-YYYY") : moment(data.startDate).format("DD-MM-YYYY")}
                                        </div>
                                      )}
                                      {data.endDate && (
                                        <div className={isExpired ? "text-danger d-flex align-items-center mt-0.5" : "text-muted d-flex align-items-center mt-0.5"}>
                                          <i className="fa fa-calendar-check mr-1" style={{ fontSize: '10px' }} />
                                          End: {data.endLocalDate ? moment(data.endLocalDate, 'YYYY-MM-DD').format("DD-MM-YYYY") : moment(data.endDate).format("DD-MM-YYYY")}
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="col-6">
                                    <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Sessions & Mobile</span>
                                    <div className="text-dark font-weight-700 mt-1" style={{ fontSize: '12.5px' }}>
                                      <i className="fa fa-layer-group mr-1 text-warning" style={{ fontSize: '11px' }} />
                                      {data.numberOfSessions || 0} Sessions
                                    </div>
                                    {data.mobileNumber && (
                                      <div className="mt-0.5">
                                        <a href={"tel:" + data.mobileNumber} className="text-muted font-weight-600 d-flex align-items-center" style={{ fontSize: '11px', textDecoration: 'none' }}>
                                          <i className="fa fa-phone-alt mr-1 text-success" style={{ fontSize: '10px' }} />
                                          {data.mobileNumber}
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Ignore status panel */}
                                {isIgnored && data.ignoreStatus && (
                                  <div className="mb-3 p-2.5 rounded border" style={{ backgroundColor: '#fff', borderColor: '#e2f3f5' }}>
                                    <Badge color="info" className="px-2 py-0.5" style={{ fontSize: '9px', fontWeight: '700' }}>IGNORED STATE</Badge>
                                    <div className="text-muted mt-1 font-weight-600" style={{ fontSize: '10.5px' }}>
                                      Until: {moment(data.ignoreStatus.ignoreDate).format("DD-MM-YYYY")}
                                    </div>
                                    {data.ignoreStatus.privateNote && (
                                      <div className="text-wrap mt-1 text-dark" style={{ fontSize: '10.5px', fontStyle: 'italic', lineHeight: '1.3' }}>
                                        Reason: {data.ignoreStatus.privateNote}
                                      </div>
                                    )}
                                  </div>
                                )}

                                {/* Bottom Actions tray */}
                                <div className="d-flex justify-content-between align-items-center mt-3 pt-3" style={{ borderTop: '1px solid #f1f3f9' }}>
                                  {/* Call & Chat Hub */}
                                  <div className="d-flex" style={{ gap: '8px' }}>
                                    {userStateForMessage === 'Connecting' || userStateForMessage === 'On call' ? (
                                      <Button color="danger" size="sm" className="btn-icon-only rounded-circle" onClick={() => this.rejectCall(data.mobile)} title="Hang up">
                                        <i className="fa fa-phone" style={{ fontSize: '12px' }} />
                                      </Button>
                                    ) : (
                                      <Button color="secondary" size="sm" className="btn-icon-only rounded-circle shadow-sm" disabled={isActive} onClick={() => this.callInit(data, globalIndex)} title="Call student" style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}>
                                        <i className="fa fa-phone text-success" style={{ fontSize: '12px' }} />
                                      </Button>
                                    )}
                                    <Button color="secondary" size="sm" className="btn-icon-only rounded-circle shadow-sm" onClick={() => this.clientConnect(globalIndex)} title="Chat history" style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}>
                                      <i className="fa fa-comments text-primary" style={{ fontSize: '12px' }} />
                                    </Button>
                                  </div>

                                  {/* Primary & Secondary Action Pill Buttons */}
                                  <div className="d-flex flex-wrap justify-content-end" style={{ gap: '6px', maxWidth: '75%' }}>
                                    {data.zoomLink && (
                                      <Button color="success" size="sm" className="px-2.5 py-1.5 font-weight-700 shadow-sm" style={{ borderRadius: '20px', fontSize: '10px' }} onClick={() => this.redirectToUrl(data.zoomLink)}>
                                        <i className="fa fa-video mr-1" /> Zoom
                                      </Button>
                                    )}
                                    <Button color="primary" size="sm" className="px-2.5 py-1.5 font-weight-700 shadow-sm" style={{ borderRadius: '20px', fontSize: '10px' }} onClick={() => this.goToSection(data.classId, data.sectionId)}>
                                      <i className="fa fa-edit mr-1" /> Edit
                                    </Button>
                                    {isNotActive && (
                                      <Button color={isIgnored ? "secondary" : "warning"} size="sm" className="px-2.5 py-1.5 font-weight-700 shadow-sm" style={{ borderRadius: '20px', fontSize: '10px' }} onClick={() => this.toggleIgnoreModal(data)}>
                                        <i className="fa fa-bell-slash mr-1" /> Ignore
                                      </Button>
                                    )}
                                    <Button color="info" size="sm" className="px-2.5 py-1.5 font-weight-700 shadow-sm" style={{ borderRadius: '20px', fontSize: '10px' }} onClick={() => this.sendMail(data.classId, data.sectionId)}>
                                      <i className="fa fa-envelope mr-1" /> Mail
                                    </Button>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          );
                        })
                      ) : (
                        <div className="text-center py-4 text-muted">No private sections found.</div>
                      )}
                    </div>
                  </>
                )}

                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      className="pagination justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem className={page > 1 ? "" : "disabled"}>
                        <PaginationLink
                          onClick={() => this.changePage("prev")}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                          <span className="sr-only">Previous</span>
                        </PaginationLink>
                      </PaginationItem>

                      {(() => {
                        const pages = [];
                        const maxVisiblePages = 5;
                        let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
                        let endPage = Math.min(totalPage, startPage + maxVisiblePages - 1);

                        if (endPage - startPage + 1 < maxVisiblePages) {
                          startPage = Math.max(1, endPage - maxVisiblePages + 1);
                        }

                        // Add first page if not already in range
                        if (startPage > 1) {
                          pages.push(
                            <PaginationItem key={1}>
                              <PaginationLink onClick={() => this.changePage(1)}>
                                1
                              </PaginationLink>
                            </PaginationItem>
                          );
                          if (startPage > 2) {
                            pages.push(
                              <PaginationItem key="ellipsis1" disabled>
                                <PaginationLink>...</PaginationLink>
                              </PaginationItem>
                            );
                          }
                        }

                        // Visible page numbers
                        for (let i = startPage; i <= endPage; i++) {
                          if (i > 0) {
                            pages.push(
                              <PaginationItem key={i} className={page === i ? "active" : ""}>
                                <PaginationLink onClick={() => this.changePage(i)}>
                                  {i}
                                </PaginationLink>
                              </PaginationItem>
                            );
                          }
                        }

                        // Add last page if not already in range
                        if (endPage < totalPage) {
                          if (endPage < totalPage - 1) {
                            pages.push(
                              <PaginationItem key="ellipsis2" disabled>
                                <PaginationLink>...</PaginationLink>
                              </PaginationItem>
                            );
                          }
                          pages.push(
                            <PaginationItem key={totalPage}>
                              <PaginationLink onClick={() => this.changePage(totalPage)}>
                                {totalPage}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        }

                        return pages;
                      })()}

                      <PaginationItem
                        className={totalPage > page ? "" : "disabled"}
                      >
                        <PaginationLink onClick={() => this.changePage("next")}>
                          <i className="fas fa-angle-right" />
                          <span className="sr-only">Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>

        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={notificationCallModal}
          toggle={() =>
            this.toggleModal('notificationCallModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center'>
                  <small>{'Message'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Form role='form'>
                  <FormGroup className={notesError ? 'has-danger' : ''}>
                    <InputGroup className='input-group-alternative'>
                      <textarea
                        placeholder='Enter Message'
                        cols={100}
                        rows={5}
                        value={twillioMessage}
                        onChange={(e) =>
                          this.setState({ twillioMessage: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>

                  <div className="row text-right">
                    <div className="ml-auto" style={{ marginRight: '10px' }}>
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => this.setState({ notificationCallModal: !notificationCallModal })}
                      >
                        Cancel
                      </Button>
                      <Button
                        disabled={!!loading}
                        color="primary"
                        type="button"
                        onClick={() => this.replyMessageResponse()}
                      >
                        Send Message
                      </Button>
                    </div>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered"
          size="lg"
          isOpen={showAddHocClass}
          toggle={() => this.showAddHocClassModal(showAddHocClass)}
        >

          <div className="modal-body p-0">
            <Card className="bg-secondary shadow border-0">
              <CardHeader className="bg-transparent pb-5">
                <div className="text-muted text-center mt-2 mb-3">
                  <small>Add Addhoc class</small>
                </div>
              </CardHeader>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      this.toggle("1");
                    }}>
                    Request with time
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      this.toggle("2");
                    }}
                  >
                    Request without time
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <CardBody className="px-lg-5 py-lg-5">
                    <Form role="form">
                      <FormGroup className={sectionNameError ? "has-danger" : ""}>
                        <label>Section name</label>
                        <InputGroup className="input-group-alternative">
                          <div style={{ width: "100%" }}>
                            <Select
                              options={allSectionsData}
                              placeholder="Select section"
                              value={sectionName}
                              onChange={(e) => this.handleSectionChange(e)}
                              isSearchable={true}
                            />
                          </div>
                        </InputGroup>
                      </FormGroup>

                      <FormGroup className={startDateError ? "has-danger" : ""}>
                        <label>Start Date</label>
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Date"
                            type="date"
                            name="startDate"
                            value={startDate}
                            onChange={(e) =>
                              this.setState({
                                startDate: e.target.value,
                                startDateError: false,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>

                      <FormGroup className={startTimeError ? "has-danger" : ""}>
                        <label>Start Time</label>
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Time"
                            type="time"
                            name="startTime"
                            value={startTime}
                            onChange={(e) =>
                              this.setState({ startTime: e.target.value })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className={endTimeError ? "has-danger" : ""}>
                        <label>End Time</label>
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Time"
                            type="time"
                            name="endTime"
                            value={endTime}
                            onChange={(e) =>
                              this.setState({ endTime: e.target.value })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <label>Teacher Name</label>
                        <InputGroup className="input-group-alternative">
                          <Input
                            disabled
                            placeholder="Teacher Name"
                            type="text"
                            name="teacherName"
                            value={teacherName}
                          />
                        </InputGroup>
                      </FormGroup>

                      <FormGroup>
                        <label>Room Url</label>
                        <InputGroup className="input-group-alternative">
                          <Input
                            disabled
                            placeholder="Room Url"
                            type="text"
                            name="roomUrl"
                            value={roomUrl}
                          />
                        </InputGroup>
                      </FormGroup>

                      <FormGroup>
                        <label>Time Zone</label>
                        <InputGroup className="input-group-alternative">
                          <Input
                            disabled
                            placeholder="Time zone"
                            type="text"
                            name="roomUrl"
                            value={timeZone}
                          />
                        </InputGroup>
                      </FormGroup>

                      <FormGroup>
                        <input
                          type="checkbox"
                          name="roomUrl"
                          value={timeZone}
                          defaultChecked={isFree ? true : false}
                          onChange={() =>
                            this.setState({ isFree: !this.state.isFree })
                          }
                        />
                        <label>
                          &nbsp; Free Class
                        </label>


                      </FormGroup>

                      <div className="text-center">
                        {uploading ? (
                          <span style={{ color: "red" }}>Wait...</span>
                        ) : null}

                        <Button
                          disabled={uploading ? true : false}
                          className="my-4"
                          color="primary"
                          type="button"
                          onClick={() => {
                            this.saveAddhocClass();
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </TabPane>
                <TabPane tabId="2">
                  <CardBody className="px-lg-5 py-lg-5">
                    <Form role="form">
                      <FormGroup className={sectionNameError ? "has-danger" : ""}>
                        <label>Section name</label>
                        <InputGroup className="input-group-alternative">
                          <div style={{ width: "100%" }}>
                            <Select
                              options={allSectionsData}
                              placeholder="Select section"
                              value={sectionName}
                              onChange={(e) => this.handleSectionChange(e)}
                              isSearchable={true}
                            />
                          </div>
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <input
                          type="checkbox"
                          name="roomUrl"
                          value={timeZone}
                          defaultChecked={isFree ? true : false}
                          onChange={() =>
                            this.setState({ isFree: !this.state.isFree })
                          }
                        />
                        <label>
                          &nbsp; Free Class
                        </label>


                      </FormGroup>


                      <div className="text-center">
                        {uploading ? (
                          <span style={{ color: "red" }}>Wait...</span>
                        ) : null}

                        <Button
                          disabled={uploading ? true : false}
                          className="my-4"
                          color="primary"
                          type="button"
                          onClick={() => {
                            this.saveNotificationToParent();
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </TabPane>
              </TabContent>
            </Card>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered"
          isOpen={this.state.successModal || this.state.errorModal}
          toggle={() =>
            successModal
              ? this.toggleModal("successModal")
              : errorModal
                ? this.toggleModal("errorModal")
                : null
          }
        >


          <div className="modal-header">
            <h5 className="modal-title" id="successModalLabel">
              {modalTitle}
            </h5>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() =>
                successModal
                  ? this.toggleModal("successModal")
                  : errorModal
                    ? this.toggleModal("errorModal")
                    : null
              }
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          {this.state.successModal ? (
            <div className="modal-body" style={{ color: "green" }}>
              {message}
            </div>
          ) : this.state.errorModal ? (
            <div className="modal-body" style={{ color: "red" }}>
              {message}
            </div>
          ) : null}
          <div className="modal-footer">
            <Button
              color="primary"
              type="button"
              onClick={() =>
                successModal
                  ? this.toggleModal("successModal")
                  : errorModal
                    ? this.toggleModal("errorModal")
                    : null
              }
            >
              Ok
            </Button>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered"
          size="lg"
          isOpen={this.state.ignoreModal}
          toggle={() => this.toggleIgnoreModal()}
        >
          <div className="modal-body p-0">
            <Card className="bg-secondary shadow border-0">
              <CardHeader className="bg-transparent pb-5">
                <div className="text-muted text-center mt-2 mb-3">
                  <small>Ignore Subscription Subscription Check</small>
                </div>
              </CardHeader>
              <CardBody className="px-lg-5 py-lg-5">
                <Form role="form">
                  <FormGroup>
                    <label>Ignore Until Date</label>
                    <InputGroup className="input-group-alternative">
                      <Input
                        placeholder="Date"
                        type="date"
                        name="ignoreDate"
                        value={this.state.ignoreDate}
                        onChange={(e) =>
                          this.setState({
                            ignoreDate: e.target.value,
                          })
                        }
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <label>Ignore Reason (Private Note)</label>
                    <InputGroup className="input-group-alternative">
                      <Input
                        placeholder="Reason for ignoring subscription"
                        type="textarea"
                        name="ignoreNote"
                        value={this.state.ignoreNote}
                        onChange={(e) =>
                          this.setState({ ignoreNote: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>

                  <div className="text-center">
                    <Button
                      className="my-4"
                      color="primary"
                      type="button"
                      onClick={() => {
                        this.handleIgnoreSave();
                      }}
                    >
                      Save Ignore
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>
      </>
    );
  }
}

export default PrivateSection;
